import React from "react";
import { PopupButton } from "react-calendly";

const CalendlyButton = (props) => {
  const {calendlyUrl} = props;
  return (
    <div className="calendlybutton">
      <PopupButton
        url={calendlyUrl}
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById("root")}
        text="Schedule a call!"
      />
    </div>
  );
};

export default CalendlyButton;